module.exports = __webpack_public_path__ + "static/img/8.df1c9a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/8.png
// module id = e9ZO
// module chunks = 0